import { ValueChainGraph } from "src/components/ValueChain/ValueChainGraph";
import { useValueChain } from "src/api/client-api/valueChain/useValueChain";
import { useProductMetadataContext } from "src/context/Product/Metadata/useProductMetadata";
import { Loading } from "src/components/utils/Loading";
import { useNavigate } from "react-router";
import { URLHandler } from "src/services/URLHandler";
import { getUnviewableIngredientIds } from "src/pages/Product/lineItemAccess";
import { useFoodpilotContext } from "src/context/FoodpilotContext";

export const ProductValueChain = () => {
    const { product } = useProductMetadataContext();
    const { selectedCompany } = useFoodpilotContext();
    const navigate = useNavigate();

    const { data, isLoading } = useValueChain(product?.id);

    const handleEntityClick = (entity: { id: number; title: string; type: string }) => {
        if (!selectedCompany) return;

        // Navigate to the entity's scores page
        if (entity.type === "ingredient") {
            if (getUnviewableIngredientIds(product?.productIngredients).has(entity.id)) return;
            navigate(URLHandler.ingredient.scores(selectedCompany.id, entity.id));
        } else if (entity.type === "intermediate_product" || entity.type === "product") {
            navigate(URLHandler.product.scores(selectedCompany.id, entity.id));
        }
    };

    if (isLoading || !product) {
        return <Loading />;
    }

    return (
        <ValueChainGraph
            data={data}
            rootEntity={{
                id: product.id,
                title: product.title,
                type: "product",
                isIntermediate: product.isIntermediate,
                ownedByName: product.ownedBy?.name,
            }}
            onEntityClick={handleEntityClick}
            height={700}
            showControls={true}
        />
    );
};
